import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/data';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const totalSlides = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent(((index % totalSlides) + totalSlides) % totalSlides);
  }, [totalSlides]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(timer);
  }, [totalSlides]);

  return (
    <section className="relative h-[480px] md:h-[620px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-800 ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40" />
        </div>
      ))}

      <div className="relative z-20 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-3xl leading-tight">
          {heroSlides[current].title}
        </h1>
        <p className="text-base md:text-lg text-background-200 mb-8 max-w-xl">
          {heroSlides[current].subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/seoul"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            探索首尔
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 backdrop-blur-sm font-medium rounded-full border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-background-50 w-7'
                : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}